import { render, staticRenderFns } from "./SfAlert.vue?vue&type=template&id=3cd1f524"
import script from "./SfAlert.vue?vue&type=script&lang=js"
export * from "./SfAlert.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfAlert.vue?vue&type=style&index=0&id=3cd1f524&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "820a7574"
  
)

export default component.exports